import React from "react";
import { useDispatch } from "react-redux";

import { unsubscribeMembership, unsubscribeSubscription } from "../../services/subscribers";
import { showAlert } from "../../store/ducks/alert";

import CloseIcon from "@material-ui/icons/Close";
import { IconButton, Button } from "@material-ui/core";

const Unsubscribe = ({ onClose, subscription }) => {
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    try {
      if(subscription.isMember === '✅ Sim') {
        await unsubscribeMembership(subscription.uid);
        dispatch(showAlert("success", "Membership canceled!"));
        window.location.reload();
      } else {
        await unsubscribeSubscription(subscription.uid); // Only subscriber
        dispatch(showAlert("success", "Subscription canceled!"));
        window.location.reload();
      }
      } catch (ex) {
      dispatch(
        showAlert("error", "Error! We could not cancel this subcription. 😔")
      );
    }
  };

  return (
    <div className="unsubscribe-container">
      <div className="unsubscribe-container-top">
        <h2>Are you sure you want to cancel this subscription?</h2>

        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <div>
        <h4>{subscription.uid}</h4>
      </div>
      <Button
        onClick={handleSubmit}
        variant="contained"
        className="modal-btn"
      >
        Yes
      </Button>
    </div>
  );
};
export default Unsubscribe;
